(function() {
  angular.module('admin')
  .directive('inArray', function() {
      return {
        restrict: 'A',
        require: 'ngModel',
        link: function($scope, element, attrs, ngModel) {
          let array;
          $scope.$watch(attrs.inArray, function(val) {
            array = val;
          });
          ngModel.$validators.inArray = (val) => {
            if (!val) {
              return true;
            }
            return !!_.find(array, (e) => e.toUpperCase() == val.toUpperCase());
          };

        }
      };
    });
})();

